import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export function getAssociationsForObject(fromObjectTypeId, fromObjectId, toObjectTypeId) {
  return http.get(`associations/v1/associations/${fromObjectTypeId}/${fromObjectId}/associations-to/${toObjectTypeId}`, {
    portalId: PortalIdParser.get()
  });
}